// claw 域内主题相关常量。主题状态管理统一交给 next-themes，这里只保留外部需要复用的常量。

export const CLAW_THEME_STORAGE_KEY = 'vidu-claw-theme';

export const CLAW_THEMES = ['dark', 'light'] as const;

export type ViduTheme = (typeof CLAW_THEMES)[number];

export const DEFAULT_CLAW_THEME: ViduTheme = 'dark';

// claw 路径之外的页面默认按 dark 渲染，离开 claw 时把 <html> 还原到这个主题。
export const FALLBACK_CLAW_THEME: ViduTheme = 'dark';
